export default __webpack_public_path__ + "static/media/ubereats-light.866c1923.svg";